export const __ChangePasswordLang = {
    change_password: 'تغییر رمز عبور',
    current_password: 'رمز فعلی',
    new_password: 'رمز جدید',
    close: 'بستن',
};
